import React from 'react';
import CommercialBreakScreen from 'screens/Game/CommercialBreakScreen';

const PreviewCommercialBreakScreen = () => {
  return <CommercialBreakScreen />;
};

export default PreviewCommercialBreakScreen;
